import dynamicLaborValueUrl from './dynamicLaborValueComponent.html';

export default {
  templateUrl: dynamicLaborValueUrl,
  controllerAs: 'ctrl',
  bindings: {
    unit: '<',
    value: '<',
  },
};
